var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBubble)?_c('ul',{staticClass:"vbuy-dynamic",class:{ 'in-app': _vm.env.isVivoApp },attrs:{"aria-hidden":"true"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.bubbleHtml)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }